import { type FC } from 'react';

import { Spinner } from 'dibs-elements/exports/Spinner.tsx';
import overlayStyles from './OverlaySpinnerAdditional.module.css';

export const Loader: FC = () => (
    <div className={overlayStyles.container}>
        <Spinner />
    </div>
);
